import React from 'react'

export interface AppContextInterface {
  navbarMenuId: string
  setNavbarMenuId: (id: string) => void
}

const AppContext = React.createContext<AppContextInterface | null>(null)
export default AppContext
